import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Stats from "@/components/site/Stats";
import Services from "@/components/site/Services";
import Portfolio from "@/components/site/Portfolio";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import Manifesto from "@/components/site/Manifesto";
import Clients from "@/components/site/Clients";
import Testimonials from "@/components/site/Testimonials";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main className="bg-[#050505]" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Stats />
      <Portfolio />
      <EditorialMarquee />
      <Services />
      <Manifesto />
      <Clients />
      <Testimonials />
      <QuoteForm />
      <Footer />
    </main>
  );
}
